const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b720f1cc5e9962fe4a6fa29864d4d5dd22bd6543"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"b720f1cc5e9962fe4a6fa29864d4d5dd22bd6543"};
      